import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxhmjyje4t: FaireProductEntity = {
  token: "p_mxhmjyje4t",
  type: "product",
  name: "Kid Book My LullaBible for Girls Padded Hardcover Board Book",
  brandToken: "b_3811aa80",
  brandName: "Christian Art Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/5a9bacb60492be9ef64ecfd7bd016e691a8869acb489e450bdca848830618e57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d86c42aada8f3c85e7aae828da189ff984be727c0361d656ee33da2e9a62edf7.jpeg",
    "https://cdn.faire.com/fastly/c16ca091695133d8778676555d0a99acc43a2d40d3e12c46f1f3c87cbd73157b.jpeg",
    "https://cdn.faire.com/fastly/06d143c97dc751b8f9201b687add2f5d4cd72106107c48042239388916f51f5e.jpeg",
  ],
  priceDollars: 10.39,
  description:
    'The powerful Scripture and prayers contained in  My LullaBible for Girls will touch you deeply. With its beautiful design and meaningful poetry, this is a must have for any family with small children.\n52 Full-Color Pages, Padded Hardcover Board Book, Brilliant Full-Color Illustrations, Silver Foil Cover Accents, Personalization Page for Gift-Giving. Size: 8.5" x 7.7" x 1.6" (216 x 196 x 41mm)',
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:02.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
